import { KeyedMutator } from "swr";

import { API_URL } from "constants/api";
import { useSwr } from "hooks/useSwr";
import { RequestService } from "pages/OptionDetail/constants";

const useFindRequestServiceById = (
  optionId: string,
  requestServiceId?: string
): {
  requestService: RequestService;
  error: Error;
  mutate: KeyedMutator<RequestService>;
} => {
  const { data, error, mutate } = useSwr<RequestService>(
    requestServiceId ? `${API_URL}/option/${optionId}/request-service/${requestServiceId}` : null
  );

  return { requestService: data, error, mutate };
};

export default useFindRequestServiceById;
